import { Text } from '@evisort/eds/components/Text/Text';

import { EM_DASH } from '~/common/constants/unicode';

type Props = {
  text: string | null;
};

/** Plain `Text` at a fixed size, for the `text` READ variant — dense contexts
 *  (e.g. table cells) that can't rely on an ambient font size. */
export function ReadTextDisplay({ text }: Props) {
  return (
    <Text tone={text ? undefined : 'subdued'} variant="body-m">
      {text ?? EM_DASH}
    </Text>
  );
}
